import React, {useEffect} from 'react'
import HubspotForm from 'react-hubspot-form'
import './form.scss'
function Form({ portalId, formId }) {

    useEffect(() => {
        // Hook into the loadScript method and replace the script URL
        const observer = new MutationObserver(() => {
            const scripts = document.head.getElementsByTagName('script');
            for (const script of scripts) {
                if (script.src.includes('//js.hsforms.net/forms/v2.js')) {
                    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
                }
            }
        });

        // Observe the <head> element for script additions
        observer.observe(document.head, { childList: true, subtree: true });

        // Cleanup observer on component unmount
        return () => observer.disconnect();
    }, []);

    if (!portalId || !formId) return null;

    return (
        <div className="hubspot-form" id="hubspot-form">
            {/* portalId="2642977"
            formId="c129786e-2eb0-47df-a488-3142b7d99715" */}
            <div>
                <HubspotForm
                    portalId={portalId}
                    formId={formId}
                    region="eu1"
                    onFormSubmit={() => {
                        window.dataLayer.push({
                            event: 'contact_submit_click',
                            eventCategory: 'form_submit'
                        })
                    }}
                    onFormSubmitted={() => {
                        window.dataLayer.push({
                            event: 'contact_submitted',
                            eventCategory: 'form_submit'
                        })
                    }}
                    onReady={(form) => console.log('Form ready!')}
                    loading={<div>Loading...</div>}
                    errorClass={'field_required'}
                />
            </div>
        </div>
    )
}

export default Form
